// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const avalugg: PokeData = {
  "id": 713,
  "name": "avalugg",
  "height": 20,
  "weight": 5050,
  "base_experience": 180,
  "types": [
    PokeType.ICE
  ],
  "api_moves": [
    "tackle",
    "body-slam",
    "take-down",
    "double-edge",
    "bite",
    "blizzard",
    "recover",
    "harden",
    "skull-bash",
    "sharpen",
    "curse",
    "powder-snow",
    "protect",
    "icy-wind",
    "rapid-spin",
    "crunch",
    "ice-ball",
    "iron-defense",
    "avalanche",
    "ice-fang",
    "wide-guard",
    "icicle-crash"
  ],
  "moves": [
    "tackle",
    "body-slam",
    "bite",
    "blizzard",
    "curse",
    "protect",
    "crunch",
    "avalanche",
    "ice-fang",
    "hailstorm",
    "ice-shard",
    "ice-wave",
    "icicle-dagger"
  ],
  "evolution_chain": {
    "id": 366,
    "item": null,
    "species": [
      {
        "name": "bergmite",
        "order": 712,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "avalugg",
        "order": 713,
        "types": [
          PokeType.ICE
        ],
        "evolves_from_species_id": 712,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 37,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 168,
    "speed": 45,
    "ability_power": 187
  },
  "stat_changes": [],
  "catch_rate": 55,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
